import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import AppliedFilter from './AppliedFilter'

function normalizeLabels (labels, onFilterChange) {
  return labels.map(label => {
    return {
      title: label,
      value: label,
      onClick: onFilterChange
    }
  })
}

const PublicLabelSelector = ({ labels, selected, onFilterChange }) => {
  if (labels.length === 0) {
    return null
  }
  labels = normalizeLabels(labels, onFilterChange)
  return <DropdownControl
    align={'adjust'}
    trigger={<ButtonControl title={selected ? <AppliedFilter type={selected.type} name={selected.name} /> : 'Filter by label'} class={'filter qa-label-filter'} icon={'arrowDropdown'} />}
    items={labels}
  />
}

export default PublicLabelSelector
